/* eslint-disable no-console */
import type { Logger as PinoLogger } from '@seek/logger';

export type Logger = Pick<
  PinoLogger,
  'info' | 'error' | 'warn' | 'debug' | 'fatal' | 'trace'
>;

const logger: Logger = {
  debug: (obj: unknown, msg?: string, ...args: any[]) => {
    console.debug(obj || msg, msg || args);
  },
  error: (obj: unknown, msg?: string, ...args: any[]) => {
    console.error(obj || msg, msg || args);
  },
  fatal: (obj: unknown, msg?: string, ...args: any[]) => {
    console.error(obj || msg, msg || args);
  },
  info: (obj: unknown, msg?: string, ...args: any[]) => {
    console.info(obj || msg, msg || args);
  },
  trace: (obj: unknown, msg?: string, ...args: any[]) => {
    console.trace(obj || msg, msg || args);
  },
  warn: (obj: unknown, msg?: string, ...args: any[]) => {
    console.warn(obj || msg, msg || args);
  },
};

export default logger;
